export default {
  supportedCountries: {
    data: null,
    loading: false,
    error: null,
  },
};
